export const USERS = [
  {
    email: "vlad@gmail.com",
    password: "vlad",
  },

  {
    email: "olga@gmail.com",
    password: "olga",
  },

  {
    email: "123@ukr.net",
    password: "123",
  },

  {
    email: "VR@gmail.com",
    password: "123vr",
  },
];
